module.exports = ".container {\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.table-bordered {\n    margin: 0 auto !important;\n}\n\n.table {\n    width: 95% !important;\n}\n\n.modal-wrapper {\n    min-height: 700px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/organization-details/organization-details-edit/address/addresses-manage-grid/addresses-manage-grid.component.css
// module id = ./src/app/organization/components/organization-details/organization-details-edit/address/addresses-manage-grid/addresses-manage-grid.component.css
// module chunks = main